// Partners have every admin permission, plus revenue in Analytics.
// Mirrors roleAllowed in the server's middleware/auth.js.
export function roleAllowed(role, allowedRoles) {
  return allowedRoles.includes(role) || (role === 'partner' && allowedRoles.includes('admin'));
}

// Analytics shows revenue to partners only; everyone else sees views and
// audience numbers. Mirrors services/analytics/access.js on the server.
export function seesRevenue(role) {
  return role === 'partner';
}
